import React from 'react'
import * as S from './styles'
import Skeleton from 'react-loading-skeleton'
import 'react-loading-skeleton/dist/skeleton.css'
const BarChart = ({
  type = 'featured',
  rankBy = 'value',
  data,
  title,
  subtitle,
  customBody,
  breakLine,
  icon,
  barStyle,
  maxColor,
  transformData,
  labelWidth,
  loading
}) => {
  // Props:
  // type => 'featured' || 'list'
  // rankBy => 'value' || 'order'
  // data => [{label: string, value: number, color: string, decorator: {label || value}}]
  // title? => string
  // subtitle? => string
  // customBody? => ReactElement
  // breakLine => boolean
  // icon => ReactElement
  // barStyle? => {height: string, width: string, ...}
  // maxColor => boolean
  // transformDate => {value: (value) => value.transformation, label: (label) => label.transformation}
  // loading => boolean
  // labelWidth => number
  const maxData = {
    value: data ? Math.max(...data.map(item => item.value)) : 1,
    order: 1
  }

  return (
    <>
      {loading
        ? <S.CardSkeleton>
          <Skeleton height='250px' />
        </S.CardSkeleton>
        : <S.Container>
          {icon && <S.IconWrapper>{icon}</S.IconWrapper>}
          {title && <S.Title>{title}</S.Title>}
          {subtitle && <S.Description>{subtitle}</S.Description>}
          <S.BarChartWrapper breakLine={breakLine} type={type}>
            {data?.map(item => (
              <S.Bar
                data-testid='barChart'
                key={item.label}
                value={item.value}
                color={item.color}
                maxData={maxData[rankBy]}
                type={type}
                customHeight={barStyle?.height}
                customWidth={barStyle?.width}
                aria-label={'Número de' + item.label + ':' + item.value}
                rankBy={rankBy}
              >
                <S.Qtd
                  value={item.value}
                  maxData={maxData[rankBy]}
                  type={type}
                  maxColor={maxColor}>
                  {item.decorator?.prefix?.value ?? '' }{transformData?.value ? transformData.value(item.value) : item.value}{item.decorator?.suffix?.value ?? ''}
                </S.Qtd>
                <S.Label
                  value={item.value}
                  maxData={maxData[rankBy]}
                  type={type}
                  labelWidth={labelWidth}
                  maxColor={maxColor}>
                  {item.decorator?.prefix?.label ?? '' }{transformData?.label ? transformData.label(item.value) : item.label}{item.decorator?.suffix?.label ?? ''}
                </S.Label>
              </S.Bar>
            ))}
          </S.BarChartWrapper>
          {customBody && customBody}
        </S.Container>
      }
    </>
  )
}

export default BarChart
